import { c as _c } from "react/compiler-runtime";
import { SeeMoreReviewsClickEvent } from '@/features/course-landing-page/events/events';
import { publishEvent } from '@udemy-v2/event-tracking';
import { useI18n } from '@udemy-v2/i18n';
import { Button } from '@udemy-v2/react-core-components';
import classNames from 'classnames';
import styles from './reviews-modal-button.module.scss';
interface ReviewsModalButtonProps {
  frontendTrackingId?: string;
  reviewableObjectId: number;
  reviewableObjectType: string;
  label?: string;
  className?: string;
  fullWidth?: boolean;
  udStyle?: 'secondary' | 'ghost';
  onClick: () => void;
}
export const ReviewsModalButton = t0 => {
  const $ = _c(19);
  const {
    frontendTrackingId,
    reviewableObjectId,
    reviewableObjectType,
    label: t1,
    className,
    fullWidth: t2,
    udStyle: t3,
    onClick
  } = t0;
  const label = t1 === undefined ? "Show all reviews" : t1;
  const fullWidth = t2 === undefined ? true : t2;
  const udStyle = t3 === undefined ? "secondary" : t3;
  const {
    gettext
  } = useI18n();
  let t4;
  if ($[0] !== frontendTrackingId || $[1] !== reviewableObjectId || $[2] !== reviewableObjectType) {
    t4 = () => {
      if (frontendTrackingId) {
        publishEvent(new SeeMoreReviewsClickEvent({
          courseTrackingId: frontendTrackingId,
          reviewableObjectId,
          reviewableObjectType
        }));
      }
    };
    $[0] = frontendTrackingId;
    $[1] = reviewableObjectId;
    $[2] = reviewableObjectType;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const trackSeeMoreReviewsClick = t4;
  let t5;
  if ($[4] !== onClick || $[5] !== trackSeeMoreReviewsClick) {
    t5 = () => {
      trackSeeMoreReviewsClick();
      onClick();
    };
    $[4] = onClick;
    $[5] = trackSeeMoreReviewsClick;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const handleOnButtonClick = t5;
  const t6 = udStyle === "ghost";
  let t7;
  if ($[7] !== className || $[8] !== fullWidth || $[9] !== t6) {
    t7 = classNames(className, {
      "ud-link-underline": t6,
      [styles["full-width-button"]]: fullWidth
    });
    $[7] = className;
    $[8] = fullWidth;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== gettext || $[12] !== label) {
    t8 = gettext(label);
    $[11] = gettext;
    $[12] = label;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== handleOnButtonClick || $[15] !== t7 || $[16] !== t8 || $[17] !== udStyle) {
    t9 = <Button onClick={handleOnButtonClick} data-purpose="show-reviews-modal-trigger-button" size="medium" udStyle={udStyle} className={t7}>{t8}</Button>;
    $[14] = handleOnButtonClick;
    $[15] = t7;
    $[16] = t8;
    $[17] = udStyle;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  return t9;
};